import { API } from "../config";
import { getCookie } from "../helper/cookieFunction";

const login = (mobile_no: string | number) =>
  API.post("/check/mobile", { mobile_no }).then(
    (res: any) => res,
    (err: any) => err
  );

export const sendOtp = (mobile_no: string | number) =>
  API.post("/send/otp", { mobile_no }).then(
    (res: any) => res,
    (err: any) => err
  );

export const guestOtp = (
  country_code: string | number,
  number: string | number,
  extra: Record<string, any> = {}
) =>
  API.post("/send/guest/otp", { country_code, number, ...extra }).then(
    (res: any) => res,
    (err: any) => err
  );
export const userLogin = (
  userName: string | number,
  password: string | number
) =>
  API.post(
    "/store/group/login",
    {
      username: userName,
      password: password,
    },
    {
      headers: {
        Platform: "Qs",
      },
    }
  ).then(
    (res: any) => res,
    (err: any) => err.response
  );

export const checkGuestOtp = (res: {
  OTP: string;
  phoneNumber: string;
  countryCode: string;
  firstName: any;
  provider?: any;
}) =>
  API.post("/check/guest/otp", {
    code: res.OTP,
    country_code: res.countryCode,
    number: res.phoneNumber,
    first_name: res.firstName,
    provider: res.provider || null,
  }).then(
    (res: any) => res,
    (err: any) => err
  );

export const socialLogin = (res: {
  userEmail: string;
  Title: string;
  titleValue: string;
  loginSource: string;
}) =>
  API.post("/social/login", {
    username: res.userEmail,
    title: res.Title,
    value: res.titleValue,
    source: res.loginSource,
  }).then(
    (res: any) => res,
    (err: any) => err
  );

export const getStoreDetial = (slug: string, result: string) =>
  API.post(`/branch/${slug}`, {
    headers: {
      response: result,
    },
  }).then(
    (res: any) => res,
    (err: any) => err.response
  );

export const getBookingCategories = (id: number | string) =>
  API.get(`/booking/category?branch=${id}&active=1`).then(
    (res: any) => res,
    (err: any) => err.response
  );
export const getSingleCategory = (id: number | string, bId: number | string) =>
  API.get(`/booking/category/single/${bId}?branch=${id}&active=1`).then(
    (res: any) => res,
    (err: any) => err.response
  );
export const getBookingCategoriesExtras = (id: number | string) =>
  API.get(`/booking/extra/category/${id}?active=1`).then(
    (res: any) => res,
    (err: any) => err.response
  );

export const getBookingFieldsExtras = (id: number | string) =>
  API.get(`/booking/extra/field/${id}?active=1`).then(
    (res: any) => res,
    (err: any) => err.response
  );

export const getAllSlots = (id: number | string) =>
  API.get(`/booking/slot/${id}?active=1`).then(
    (res: any) => res,
    (err: any) => err.response
  );

export const getSlotsTime = (id: number | string, date: any = null) =>
  API.get(`/booking/time/${id}${date ? `?active=1&date=${date}` : `?active=1`}`).then(
    (res: any) => res,
    (err: any) => err.response
  );
export const getInvoice = (id: number | string) =>
  API.get(`/booking/single/${id}`, {
    headers: {
      Response: 'detail'
    },
  }).then(
    (res: any) => res,
    (err: any) => err.response
  );
export const getAdvertising = (id: number | string) =>
  API.get(`/advertising?branch=${id}`).then(
    (res: any) => res,
    (err: any) => err.response
  );

export const addBookingCustomer = (payload: any, token: string,) => {
  API.post("/booking/customer/add", payload, {
    headers: {
      Authorization: `Bearer ${getCookie("tokenAuth")}`,
    },
  }).then(
    (res) => res,
    (err) => err.response
  );
}
export const getGuestPricing = (id: number | string) =>
  API.get(`booking/slot/guest-pricing/${id}`).then(
    (res: any) => res,
    (err: any) => err.response
  );

export const getPackeges = (id: number | string | null) =>
  API.get(`/booking/package/${id}?active=1`).then(
    (res: any) => res,
    (err: any) => err.response
  )

export const payBookingInvoice = (bookingInvoiceId: number | string, payload: any) =>
  API.post(`/booking/customer/pay/${bookingInvoiceId}`, payload, {
    headers: {
      Authorization: `Bearer ${getCookie("tokenAuth")}`,
    },
  }).then(
    (res: any) => res,
    (err: any) => err.response
  );

export const apiService = {
  login,
  sendOtp,
  guestOtp,
  userLogin,
  socialLogin,
  checkGuestOtp,
  getStoreDetial,
  getBookingCategories,
  getAllSlots,
  getSlotsTime,
  getBookingCategoriesExtras,
  getBookingFieldsExtras,
  addBookingCustomer, getSingleCategory,
  getInvoice,
  getAdvertising,
  getGuestPricing,
  getPackeges,
  payBookingInvoice
};
